import React from "react";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Spin,
  Image,
  Card,
  Divider,
  Result,
  message,
  Table,
} from "antd";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import moment from "moment";
import * as serverconfig from "../serverconn";
import { Col, Row } from "reactstrap";
import {
  UserOutlined,
  LockOutlined,
  LoadingOutlined,
  MailOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";

var CryptoJS = require("crypto-js");

const FormItem = Form.Item;
const { Option } = Select;
const dateFormat = "DD/MM/YYYY";
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token = "";
var sacco = "";
var username = "";

class DataUploadForm_Json extends React.Component {
  state = {
    date: moment().format(dateFormat).toString(),
    datalist: [],
    uploadtype: "",
    columns: [],
    message: "",
    companyprofile: {},
    members:[],
    selectedaccount:''
  };

  componentDidMount() {
    if (localStorage.getItem("sacco")) {
      sacco = CryptoJS.AES.decrypt(
        localStorage.getItem("sacco"),
        "my-secret-key@12345"
      ).toString(CryptoJS.enc.Utf8);
      username = CryptoJS.AES.decrypt(
        localStorage.getItem("username"),
        "my-secret-key@123"
      ).toString(CryptoJS.enc.Utf8);
    } else {
      sacco = "";
      username = "";
    }

    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    } else {
      token = "";
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };


    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
    })


    axios
      .get(`${serverconfig.backendserverurl}/api/app_profile/${1}`)
      .then((res) => {
        this.setState({
          companyprofile: res.data,
        });
        this.setState({ datarequested: false });
      });
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileContent = e.target.result;
        try {
          const jsonData = JSON.parse(fileContent);
          //console.log(JSON.stringify(jsonData))
          //chekc if areasr data
            this.setState({ datalist: jsonData});
          
       
          message.success(`${file.name} file uploaded successfully.`);
        } catch (parseError) {
          console.error("Error parsing JSON:", parseError);
          message.error("Invalid JSON file. Please upload a valid JSON file.");
        }
      };

      reader.readAsText(file);
    } catch (error) {
      console.error("Error reading file:", error);
      message.error("Error reading file. Please try again.");
    }
  };

  //submit button pressed
  handleFormSubmit = () => {
    if (this.state.datalist.length <= 0) {
      message.error("Datalist cant be empty.");
    }else if (this.state.selectedaccount===""){
      message.error("Please select member account")
    } else {
      const dataSizeBytes = JSON.stringify(this.state.datalist).length;
      // Convert bytes to gigabytes
      const dataSizeGB = dataSizeBytes / (1024 * 1024 * 1024); // 1 GB = 1024 MB = 1024*1024 KB = 1024*1024*1024 Bytes
      message.info("Datasize: " + String(dataSizeGB) + " GBs");

      this.setState({ datarequested: true });

      let form_data = new FormData();
      form_data.append("sacco", sacco);
      form_data.append("datalist", JSON.stringify(this.state.datalist));
      form_data.append("username", username);
      form_data.append("uploadtype", this.state.uploadtype);
      form_data.append("member_id", this.state.selectedaccount);

      axios
        .post(
          serverconfig.backendserverurl + "/customqueries/final_dataupload_json",
          form_data,
          {
            headers: {
              "content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          this.setState({ message: res.data.message });
          console.log(res.data);
          this.setState({ datarequested: false });
          this.setState({ datasubmittedsuccessfully: true });
        })
        .catch((error) => console.log(error));
    }
  };

  render() {
    if (this.state.datarequested === true) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin indicator={antIcon} />
        </div>
      );
    } else {
      if (this.state.datasubmittedsuccessfully === true) {
        return (
          <Card>
            <Result
              status="success"
              title="Successful"
              subTitle={this.state.message}
              extra={[
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.reload(false);
                  }}
                >
                  Finish
                </Button>,
              ]}
            />
          </Card>
        );
      } else {
        /// Generate columns dynamically based on keys of the first item
        const columns =
          this.state.datalist.length > 0
            ? Object.keys(this.state.datalist[0]).map((key) => ({
                title: key,
                dataIndex: key,
                key: key,
              }))
            : [];

        return (
          <div>
            <h3>Data upload section</h3>
            <h6 style={{ color: "red" }}>
              Note: Do not change excel template headings && maintain date
              formats. Records with wrong formats will not be added.
            </h6>
            <Card>
              <Form>
                <FormItem label="Upload type">
                  <Select
                    value={this.state.uploadtype}
                    onChange={(val) => {
                      this.setState({ uploadtype: val });
                    }}
                    placeholder="Upload type"
                  >
                    <Option value="journal_txns">journal_txns upload</Option>
                    <Option value="statement_txns">statement_txns upload</Option>
                    <Option value="loanapplications">loanapplications upload</Option>
                    <Option value="loanassessments">loanassessments upload</Option>
                    <Option value="loanapprovals">loanapprovals upload</Option>
                    <Option value="loanissuances">loanissuances upload</Option>

                    <Option value="loanshedules">loanshedules upload</Option>
                    <Option value="loanrepayments">loanrepayments upload</Option>

                  </Select>
                </FormItem>


                <FormItem label="Account">
                    <Select 
                    placeholder="Account No | Name" 
                    style={{  }} 
                    value={this.state.selectedaccount}
                    onChange={(val)=>{
                      this.setState({selectedaccount:val})
                    }} 
                    showSearch
                    optionFilterProp="children"
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                                          
                    >
                      {this.state.members.map(
                        (accnt)=>(
                          <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                        ))}
                    </Select>
                </FormItem>



                <FormItem label="Json data template">
                  <Input
                    type="file"
                    accept=".json"
                    onChange={this.handleFileChange}
                  />
                </FormItem>
              </Form>
            </Card>

            <br></br>
            {this.state.datalist.length > 0 && (
              <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <h2>Processed Data</h2>
                  &nbsp;&nbsp;
                  <Button
                    type="primary"
                    onClick={() => {
                      this.handleFormSubmit();
                    }}
                  >
                    Upload data
                  </Button>
                </div>
                <div style={{ overflowX: "auto" }}>
                  <Table
                    dataSource={this.state.datalist}
                    columns={columns}
                    scroll={{ x: 1000 }}
                    bordered
                    pagination={{
                      showQuickJumper: true,
                      showSizeChanger: true,
                    }}
                    size="small"
                  />{" "}
                  {/* Display the data in an Ant Design Table */}
                </div>
              </div>
            )}
          </div>
        );
      }
    }
  }
}

export default DataUploadForm_Json;
